/* ═══════════════════════════════════════════════════════
   NURSE X — THEME JS
   ═══════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  // ── Mobile nav toggle ──
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
      const isOpen = mobileNav.classList.contains('is-open');
      hamburger.setAttribute('aria-expanded', isOpen);
    });
  }

  // ── Quantity buttons ──
  document.querySelectorAll('.quantity-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = btn.closest('.quantity-wrap').querySelector('.quantity-input');
      if (!input) return;
      const val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'minus') input.value = Math.max(1, val - 1);
      if (btn.dataset.action === 'plus')  input.value = val + 1;
    });
  });

  // ── Product gallery thumbnails ──
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (mainImg) {
        mainImg.src = thumb.querySelector('img').src;
        mainImg.srcset = thumb.querySelector('img').srcset || '';
      }
    });
  });

  // ── Variant selection ──
  document.querySelectorAll('.variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const group = btn.closest('.variant-options');
      if (!group) return;
      group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
    });
  });

  // ── Smooth scroll for anchor links ──
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ── Cart count badge ──
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const badges = document.querySelectorAll('.cart-count');
      badges.forEach(function (b) {
        b.textContent = cart.item_count > 0 ? cart.item_count : '';
        b.style.display = cart.item_count > 0 ? 'inline' : 'none';
      });
    } catch (e) { /* silent fail */ }
  }
  updateCartCount();

});
